import React, { createContext, useContext, useState, ReactNode } from 'react';
import { HowItWorksModal } from './HowItWorksModal';

type ModalType = 'howItWorks';

interface ModalState {
  isOpen: boolean;
  type: ModalType | null;
}

interface ModalContextType {
  openModal: (type: ModalType) => void;
  closeModal: () => void;
  modalState: ModalState;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export function useModal() {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within ModalProvider');
  }
  return context;
}

interface ModalProviderProps {
  children: ReactNode;
}

export function ModalProvider({ children }: ModalProviderProps) {
  const [modalState, setModalState] = useState<ModalState>({
    isOpen: false,
    type: null
  });

  const openModal = (type: ModalType) => {
    setModalState({ isOpen: true, type });
  };

  const closeModal = () => {
    setModalState({ isOpen: false, type: null });
  };

  const value = {
    openModal,
    closeModal,
    modalState
  };

  return (
    <ModalContext.Provider value={value}>
      {children}
      
      {/* Render modals based on state */}
      {modalState.isOpen && modalState.type === 'howItWorks' && (
        <HowItWorksModal 
          isOpen={true}
          onClose={closeModal}
        />
      )}
    </ModalContext.Provider>
  );
}